import {useUserDevice} from "@pg-mono/user-device";

export const useResponsiveOpenLink = (link: string) => {
    const {isMobile} = useUserDevice();

    return () => (isMobile ? (window.location.href = link) : window.open(link, "_blank"));
};
